[
  {
    "title": "Every little help",
    "medium": "Acrylics",
    "year": "2025",
    "image": "everylittlehelp"
  },
  {
    "title": "Al Dente",
    "medium": "Acrylics collage",
    "year": "2025",
    "image": "aldente"
  },
  {
    "title": "Car Wash £10 - SOLD",
    "medium": "Acrylics",
    "year": "2025",
    "image": "carwash10"
  },
  {
    "title": "Blues up - SOLD",
    "medium": "Acrylics",
    "year": "2025",
    "image": "bluesup"
  },
  {
    "title": "Play as you are - SOLD",
    "medium": "Acrylics",
    "year": "2025",
    "image": "playasyouare"
  },
  {
    "title": "Breathe up - SOLD",
    "medium": "Acrylics",
    "year": "2025",
    "image": "breatheup"
  },
  {
    "title": "Where the woods end, there he bloomed",
    "medium": "Acrylics",
    "year": "2025",
    "image": "greenman"
  },
  {
    "title": "Market Day - SOLD",
    "medium": "Acrylics",
    "year": "2025",
    "image": "marketday"
  },
  {
    "title": "Farewell and thanks for all the graze",
    "medium": "Acrylics",
    "year": "2025",
    "image": "ufo"
  },
  {
    "title": "Le Lobster Thermidors - Sold",
    "medium": "Acrylics collage",
    "year": "2025",
    "image": "lobster"
  },
  {
    "title": "Sarapiqui",
    "medium": "Acrylics",
    "year": "2025",
    "image": "sarapiqui"
  },
  {
    "title": "YUM (Imane's medal)",
    "medium": "Acrylics",
    "year": "2024",
    "image": "imane"
  },
  {
    "title": "Inferno",
    "medium": "Acrylics",
    "year": "2024",
    "image": "inferno"
  },
  {
    "title": "Game of Shrooms 2024 - Gone",
    "medium": "3D Printed Sculpture",
    "year": "2024",
    "image": "shrooms2024"
  },
  {
    "title": "Queen for a day",
    "medium": "Mixed media sculpture",
    "year": "2024",
    "image": "queenforaday"
  },
  {
    "title": "The Call to Merenda - Sold ",
    "medium": "Acrylics",
    "year": "2024",
    "image": "calltomerenda"
  },
  {
    "title": "Crab Invaders - Sold ",
    "medium": "Acrylics and wood collage",
    "year": "2024",
    "image": "crabinvaders"
  },
  {
    "title": "Underbirds #5 Pigeon ",
    "medium": "Acrylics",
    "year": "2024",
    "image": "pigeon4theunderbirds"
  },
  {
    "title": "Underbirds #4 Sparrows - Sold",
    "medium": "Acrylics",
    "year": "2024",
    "image": "sparrows"
  },
  {
    "title": "Underbirds #3 Primitive Bird",
    "medium": "Acrylics",
    "year": "2024",
    "image": "primitive"
  },
  {
    "title": "Underbirds #2 Lapwings",
    "medium": "Acrylics",
    "year": "2024",
    "image": "lapwing"
  },
  {
    "title": "Underbirds #1 70s Gannet",
    "medium": "Acrylics",
    "year": "2024",
    "image": "gannet"
  },


  {
    "title": "Whodunnock (winner of the November 2023 LBAS competition)- SOLD",
    "medium": "Watercolour collage",
    "year": "2023",
    "image": "whodunnock"
  },
  {
    "title": "The trouble with sitters - SOLD",
    "medium": "Acrylics collage",
    "year": "2023",
    "image": "troublesitters"
  },
  {
    "title": "The reason why I am not allowed to redecorate a church",
    "medium": "Acrylics",
    "year": "2023",
    "image": "church"
  },
  {
    "title": "Nonna's Sunday",
    "medium": "Acrylics",
    "year": "2023",
    "image": "nonnas"
  },
  {
    "title": "Murmurations - SOLD",
    "medium": "Acrylics",
    "year": "2023",
    "image": "murmurations"
  },
  {
    "title": "The most over-dramatic mating dance - SOLD",
    "medium": "Acrylics collage",
    "year": "2023",
    "image": "overdrama"
  },
  {
    "title": "The 80s have been calling",
    "medium": "Acrylics",
    "year": "2023",
    "image": "et"
  },
  {
    "title": "Pigeon",
    "medium": "Air-dry clay",
    "year": "2023",
    "image": "pigeonclay"
  },
  {
    "title": "Sleeping pod",
    "medium": "Acrylics",
    "year": "2023",
    "image": "sleepingpod"
  },
  {
    "title": "Mid morning snack",
    "medium": "Gouache",
    "year": "2023",
    "image": "pelican"
  },
  {
    "title": "William Sheepspeare - SOLD",
    "medium": "Watercolour",
    "year": "2023",
    "image": "sheep"
  },
  {
    "title": "Robin Redbreast",
    "medium": "Markers and pencils",
    "year": "2023",
    "image": "robinredbreast"
  },
  {
    "title": "Onsen Macaque",
    "medium": "Markers and pencils",
    "year": "2023",
    "image": "macaque"
  },
  {
    "title": "El Paraiso",
    "medium": "Acrylics",
    "year": "2022",
    "image": "elparaiso"
  },
  {
    "title": "School of fish - SOLD",
    "medium": "Gouache",
    "year": "2022",
    "image": "schooloffish"
  },
  {
    "title": "Sloth - SOLD",
    "medium": "Pencils",
    "year": "2022",
    "image": "sloth"
  }
]